"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
Object.defineProperty(exports, "firebase", {
  enumerable: true,
  get: function get() {
    return _app["default"];
  }
});
exports.firebaseConfig = void 0;
var _app = _interopRequireDefault(require("firebase/app"));
require("firebase/storage");
require("firebase/firestore");
require("firebase/auth");
var firebaseConfig = {
  apiKey: 'AIzaSyDyoexEFOBMUV6CSx3Njqs5yCtWojZFF5c',
  authDomain: 'dokiabeta.firebaseapp.com',
  databaseURL: 'https://dokiabeta.firebaseio.com',
  projectId: 'dokiabeta',
  storageBucket: 'dokiabeta.appspot.com',
  messagingSenderId: '391417515930',
  appId: '1:391417515930:web:9726d2186d84fc61103423'
};
exports.firebaseConfig = firebaseConfig;
var app = _app["default"].initializeApp(firebaseConfig, 'dokia-beta');
var _default = app;
exports["default"] = _default;